<template>
	<v-text class="mb-5">
		{{ description }}
	</v-text>
	<div class="flex-col-reverse flex sm:flex-row sm:items-center gap-4 justify-between">
		<tw-button
			@click="() => emit('cancel')"
			class="w-full ">
			{{ t('songSelection.cancel') }}
		</tw-button>
		<tw-button
			@click="() => emit('save')"
			class="w-full btn-brand">
			{{ t('sidebar.continue') }}
		</tw-button>
	</div>
</template>

<script lang="ts">
	export default { name: 'ConfirmationCard' } // name the component
</script>

<script lang="ts" setup>
	// Language
	import {
		useI18n
	} from 'vue-i18n'
	
	const {t} = useI18n()

	const props = defineProps({
		description: {
			type: String,
			default: ""
		}
	})

	// Define emits
	const emit = defineEmits([
		'cancel',
		'save'
	])

</script>